import { createContext } from 'react';
import type { PendingOrder } from '../types/pending-orders';

// Intervalo de polling em milissegundos (30 segundos)
export const POLLING_INTERVAL = 30 * 1000; // 30 segundos

export interface PendingOrdersContextData {
  hasPendingOrders: boolean;
  pendingOrders: PendingOrder[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const PendingOrdersContext = createContext<PendingOrdersContextData>({} as PendingOrdersContextData);
